import React, { useState, useRef, useEffect } from "react";
import "../../../../../css/RecruitmentScreen/Sections.css";
import "../../../../../css/RecruitmentScreen/CollapsibleSection.css";
import FormField from "../FormField";
import YesNoRadio from "../RadioButton";
import { writeDataS7 } from "../../../../../backend/Sections/Section7/writeDataS7";
import { readDataS7 } from "../../../../../backend/Sections/Section7/readDataS7";
import errorTrackerV2 from "../Validation/Utils/ErrorTrackerV2";
import {
  addSubmissionListener,
  getIsSubmitted,
} from "../../Utils/submissionListener";
import { auth } from "../../../../../backend/firebaseConfig";
import { shouldBypassValidation } from "../../Utils/validationPolicy";

import { validateSection7, isAnyYesSelectedS7 } from "../Validation/section7";
import InputField from "../../../../DesignSystem/Inputs/InputField";
import AlertBanner from "../../../../DesignSystem/AlertBanner/AlertBanner";
import PrimaryButton from "../../../../DesignSystem/Buttons/PrimaryButton";
import SecondaryButton from "../../../../DesignSystem/Buttons/SecondaryButton";
import TextArea from "../../../../DesignSystem/Inputs/TextArea";
import Checkbox from "../../../../DesignSystem/Inputs/Checkbox";
import CheckboxGrid from "../../../../DesignSystem/Inputs/CheckboxGrid";
import CollapsibleSection from "../../../../DesignSystem/CollapsibleSection/CollapsibleSection";
import SectionAdditionalInfo from "../../../../DesignSystem/SectionAdditionalInfo/SectionAdditionalInfo";

const Section7 = ({ onValidationStatusChange }) => {
  const [formData, setFormData] = useState({
    criminalOffence: null,
    criminalOffenceRelatedToFraud: null,
    criminalOffenceRelatedToCompanies: null,
    criminalProceedings: null,
    subjectToCriminalOffence: null,

    otherConvictions: null,
    arrestedForCriminalOffence: null,
    produceDocuments: null,

    firmConvictedOfCriminalOffence: null,
    firmSummonedChargedInvestigated: null,
    firmSubjectOfCriminalProceedings: null,
    firmOrderedToProduceDocuments: null,

    judgementDebt: null,
    partyToCivilProceedings: null,

    awareOfProceedingsAganistYou: null,
    moreThanOneSetOfProceedings: null,
    claimDebtFromYou: null,

    currentJudgementDebt: null,
    failedToSatisfyJudgementDebt: null,

    filedForBankruptcy: null,
    adjudgedBankrupt: null,
    subjectOfBankruptcyRestrictions: null,
    arrangementsWithCreditors: null,
    assetsSequestrated: null,
    involvedInProceedings: null,

    financialObligations: null,
    courtAdjudgedForMisconduct: null,

    currentlyPartyToCivilProceedings: null,
    awareOfCivilProceedings: null,

    firmAdjudgedByCourt: null,
    judgementDebtAganistFirm: null,
    partyToCivilProceedingsAganistFirm: null,

    firmPartOfcivilProceedings: null,
    firmPartyToCivilProceedings: null,

    woundUpFirm: null,

    disqualifiedFromDirector: null,
    subjectToProceedings: null,
    subjectToInvestigation: null,
    notifiedOfProceedings: null,
    subjectOfInvestigationWithBusinessActivity: null,

    refusedEntry: null,
    complaintsAgainstYou: null,
    arbitrationBoard: null,

    suspendedByRegulatoryBody: null,
    subjectOfDisciplinaryAction: null,
    receivedWarning: null,
    subjectOfInvestigationByRegulatoryBody: null,
    requiredToProduceDocuments: null,
    investigationByInspector: null,
    ceasedOperating: null,
    rejectedApplication: null,
    subjectOfCivilAction: null,
    paymentServices: null,
    convictedOdCriminalOffence: null,
    boardofDirectorsNotGrantedRelease: null,

    carriedOnActivitiesWithoutAuthorization: null,
    investigatedForCarryingOnActivities: null,
    performedControlledFunctionWithoutApproval: null,
    investigatedForControlledFunction: null,
    failedToComplyWithRegulations: null,
    subjectOfDisqualificationDirection: null,

    conflictPerformanceofControlledFunctions: null,
    qualifyingOwnership: null,
    companyName: "",
    companyRegistrationNumber: "",
    natureOfOperations: "",
    registeredOffice: "",
    possessionInPercentage: "",
    closeRelativesOwnershipShares: null,
    nameOfCloseRelativesOwnershipShares: "",
    closeRelativesFinancialRelations: null,
    nameOfCloseRelativesFinancialRelations: "",
    conflictOfInterest: null,

    otherRelevantInformation: null,
    // confirmedDeclaration: null,
    // candidateName: "",
    // candidateSignature: "",
    // date: new Date().toISOString().split("T")[0],

    files: [],
    // additionalInformation: "",

    // Section-specific additional info and files
    additionalInformation_7_01: "",
    files_7_01: [],
    additionalInformation_7_02: "",
    files_7_02: [],
    additionalInformation_7_03: "",
    files_7_03: [],
    additionalInformation_7_04: "",
    files_7_04: [],
    // additionalInformation_7_05: "",
    files_7_05: [],
  });

  const [errors, setErrors] = useState({});
  const [isValid, setIsValid] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("");

  const [isSubmitted, setIsSubmitted] = useState(getIsSubmitted());
  const sectionTopRef = useRef(null);

  // Collapseable sections state
  const [collapsedSections, setCollapsedSections] = useState({
    criminalProceedings: false,
    civilProceedings: true,
    businessEmployment: true,
    regulatoryMatters: true,
    miscellaneous: true,
  });

  const toggleSection = (section, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setCollapsedSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  useEffect(() => {
    const removeListener = addSubmissionListener(setIsSubmitted);
    setIsSubmitted(getIsSubmitted());

    return () => removeListener();
  }, [isSubmitted]);

  const runValidation = (nextData) => {
    const v = validateSection7(nextData);

    const { _isValid, ...errorMap } = v;

    // Log errors for debugging
    // console.log("Section 7 Validation Errors:", errorMap);
    // console.log("Section 7 Is Valid:", _isValid);

    setErrors(errorMap);
    setIsValid(_isValid);

    errorTrackerV2.setSectionErrors("section7", errorMap);
    onValidationStatusChange(_isValid);

    return _isValid;
  };

  // load
  useEffect(() => {
    const fetchData = async () => {
      const data = await readDataS7();
      if (data) {
        setFormData((prev) => ({
          ...prev,
          ...data,
          files_7_01: data.files_7_01 || [],
          files_7_02: data.files_7_02 || [],
          files_7_03: data.files_7_03 || [],
          files_7_04: data.files_7_04 || [],
          files_7_05: data.files_7_05 || [],
        }));
      }
    };
    fetchData();
  }, []);

  // when signature exists in DB, draw it onto canvas
  // useEffect(() => {
  //   if (
  //     formData.candidateSignature &&
  //     sigCanvasRef.current &&
  //     sigCanvasRef.current.isEmpty()
  //   ) {
  //     sigCanvasRef.current.fromDataURL(formData.candidateSignature);
  //   }
  // }, [formData.candidateSignature]);

  // validate on formData change (live validation when data is loaded from database)
  useEffect(() => {
    runValidation(formData);
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ fixed: don't mutate formData directly
  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      confirmedDeclaration: checked ? true : null,
    }));
  };

  const renderError = (field) =>
    showErrors && errors[field] ? (
      <p className="error-message">{errors[field]}</p>
    ) : null;

  const renderOptions = (nomenclature) => {
    const options = nomenclatureOptions[nomenclature] || [];
    return options.map((option, index) => (
      <div key={`${option.key}-${index}`}>
        <div className="input-group-row">
          <div className="Content">
            {option.label}
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>

          <div className="input-group">
            <YesNoRadio
              name={option.key}
              value={formData[option.key]}
              onChange={handleChange}
              error={renderError(option.key)}
            />
          </div>
        </div>
        <div className="sizebox" />
      </div>
    ));
  };

  const nomenclatureOptions = {
    options_7_01_1: [
      {
        key: "criminalOffence",
        label:
          "a. Have you ever been convicted on any criminal offence? (whether spent or not and whether or not in the United Kingdom)",
      },
      {
        key: "criminalOffenceRelatedToFraud",
        label:
          "i. Involving fraud, theft, false accounting, offences against the administration of public justice (such as perjury, perverting the course of justice and intimidation of witness or jurors), serious tax offences or other dishonesty",
      },
      {
        key: "criminalOffenceRelatedToCompanies",
        label:
          "ii. Relating to companies, building societies, industrial and provident societies, credit unions, friendly societies, insurance, banking or other financial services, insolvency, consumer credit or consumer protection, money laundering, market manipulations or insider dealing?",
      },
      {
        key: "criminalProceedings",
        label:
          "b. Are you or have you ever been, the subject of any criminal proceedings, where in the UK or elsewhere?",
      },
      {
        key: "subjectToCriminalOffence",
        label:
          "c. Have you ever been given a caution in relation to any criminal offence?",
      },
    ],
    options_7_01_5: [
      {
        key: "firmConvictedOfCriminalOffence",
        label: "i. Been convicted of any criminal offence?",
      },
      {
        key: "firmSummonedChargedInvestigated",
        label:
          "ii. Been summonsed, charged with or otherwise investigated or prosecuted for any criminal offence?",
      },
      {
        key: "firmSubjectOfCriminalProceedings",
        label:
          "iii. Been the subject of any criminal proceeding which has not resulted in a conviction?",
      },
      {
        key: "firmOrderedToProduceDocuments",
        label:
          "iv. Been ordered to produce documents in relation to any criminal investigation or been the subject of a search (with or without a warrant) in relation to any criminal investigation?",
      },
    ],
    options_7_02_3: [
      {
        key: "awareOfProceedingsAganistYou",
        label:
          "i. Any proceedings that have begun, or anyone’s intention to begin proceedings against you, for a CCJ or another judgement debt?",
      },
      {
        key: "moreThanOneSetOfProceedings",
        label:
          "ii. More than one set of proceedings, or anyone’s intention to begin more than one set of proceedings, that may lead to a CCJ or other judgement debt?",
      },
      {
        key: "claimDebtFromYou",
        label:
          "iii. Anyone’s intention to claim more than £1,000 of CCJs or judgement debts in total from you?",
      },
    ],
    options_7_02_6: [
      {
        key: "filedForBankruptcy",
        label:
          "a. Filed for your own bankruptcy or had a bankruptcy petition served on you?",
      },
      { key: "adjudgedBankrupt", label: "b. Been adjudged bankrupt?" },
      {
        key: "subjectOfBankruptcyRestrictions",
        label:
          "c. Been the subject of a bankruptcy restrictions order (including an interim bankruptcy restriction order) or offered a bankruptcy restriction undertaking?",
      },
      {
        key: "arrangementsWithCreditors",
        label:
          "d. Made any arrangements with your creditors, for example, a deed of arrangement or an individual voluntary arrangement (or in Scotland a trust deed)?",
      },
      { key: "assetsSequestrated", label: "e. Had assets sequestrated?" },
      {
        key: "involvedInProceedings",
        label:
          "f. Been involved in any proceedings relating to the above matters even if such proceedings did not result in the making of any kind of order or results in any kind of agreement with you?",
      },
    ],
    options_7_02_9: [
      {
        key: "currentlyPartyToCivilProceedings",
        label:
          "a) Party to any civil proceedings? (including those covered in 7.02.2 above)",
      },
      {
        key: "awareOfCivilProceedings",
        label:
          "b) Aware of anybody’s intention to begin civil proceedings against you? (you should include any ongoing disputes whether or not such dispute is likely to results in any order against you.)",
      },
    ],
    options_7_02_10: [
      {
        key: "firmAdjudgedByCourt",
        label:
          "a) Adjudged by a court civilly liable for any fraud, misfeasance, wrongful trading or other misconduct?",
      },
      {
        key: "judgementDebtAganistFirm",
        label:
          "b) The subject of a judgement debt or award against the firm? (you should include all CCJs) made against the firm, whether satisfied or not.",
      },
      {
        key: "partyToCivilProceedingsAganistFirm",
        label:
          "c) Party to any civil proceedings which resulted in an order against the firm other than in relation to matters covered in 7.02.10a and 7.02.10b above?",
      },
    ],
    options_7_02_11: [
      {
        key: "firmPartOfcivilProceedings",
        label: "a) A part to civil proceedings?",
      },
      {
        key: "firmPartyToCivilProceedings",
        label:
          "b) Aware of anyone’s intention to begin civil proceedings against them?",
      },
    ],
    options_7_03_1: [
      {
        key: "disqualifiedFromDirector",
        label:
          "a) Disqualified from acting as a director or similar position (one where you act in a management capacity or conducts the affairs or any company, partnership or unincorporated association)?",
      },
      {
        key: "subjectToProceedings",
        label:
          "b) The subject of any proceedings of a disciplinary nature (whether or not the proceedings resulted in any findings against you)?",
      },
      {
        key: "subjectToInvestigation",
        label:
          "c) The subject of any investigation which has led or might lead to disciplinary proceedings?",
      },
      {
        key: "notifiedOfProceedings",
        label:
          "d) Notified of any potential proceedings of a disciplinary nature against you?",
      },
      {
        key: "subjectOfInvestigationWithBusinessActivity",
        label:
          "e) The subject of an investigation into allegations of misconduct or malpractice in connection with any business activity (covering internal investigation by an authorised firm, as well as investigation by a regulatory body, at any time)",
      },
    ],
    options_7_04_1: [
      {
        key: "suspendedByRegulatoryBody",
        label:
          "a) Been refused, had revoked, restricted, been suspended from or any other permission granted by any such body?",
      },
      {
        key: "subjectOfDisciplinaryAction",
        label:
          "b) Been criticized, censured, disciplined, suspended, expelled, fined or been the subject of any other disciplinary or interventional action by any such body?",
      },
      {
        key: "receivedWarning",
        label:
          "c) Received a warning (whether public or private) that such disciplinary or intentional action may be taken against you or the firm?",
      },
      {
        key: "subjectOfInvestigationByRegulatoryBody",
        label:
          "d) Been the subject of an investigation by any regulatory body, whether or not such an investigation resulted in a finding against you or the firm?",
      },
      {
        key: "requiredToProduceDocuments",
        label:
          "e) Been required or requested to produce documents or any other information to any regulatory body in connection with such an investigation (whether against the firm or otherwise)?",
      },
      {
        key: "investigationByInspector",
        label:
          "f) Been investigated or been involved in an investigation by an inspector appointed under companies or any other legislation, or required to produce documents to the Secretary of State, or any other authority, under any such legislation?",
      },
      {
        key: "ceasedOperating",
        label:
          "g) Ceased operating or resigned whilst under investigation by any such body or been required to cease operating or resign by any regulatory body?",
      },
      {
        key: "rejectedApplication",
        label:
          "h) Decided, after making an application for any license, authorization, registration, notification, membership or any permission granted by any such body, not to proceed with it?",
      },
      {
        key: "subjectOfCivilAction",
        label:
          "i) Been the subject of any civil action related to any regulated activity which has resulted in a finding by a court?",
      },
      {
        key: "paymentServices",
        label:
          "j) Provided payment services or distributed or redeemed e-money on behalf of a regulated firm or itself under any contractual agreement where that agreement was terminated by the regulated firm?",
      },
      {
        key: "convictedOdCriminalOffence",
        label:
          "k) Been convicted of any criminal offence, censured, disciplined or publicly criticized by any inquiry, by the Takeover Panel or any government or statutory authority or any other regulatory body? (other than as indicated in this group of questions)",
      },
      {
        key: "boardofDirectorsNotGrantedRelease",
        label:
          "l) Been on a board of directors in an operating undertaking that has not been granted a release from liability?",
      },
    ],
    options_7_04_2: [
      {
        key: "carriedOnActivitiesWithoutAuthorization",
        label:
          "a) Been found to have carried on activities for which authorization or registration by the FCA/PRA or any other regulatory body isrequired without requisite authorization?",
      },
      {
        key: "investigatedForCarryingOnActivities",
        label:
          "b) Been investigated for the possible carrying on of activities requiring authorization or registration by the FCA/PRA or any other regulatory body without the requisite authorization whether or not such investigation resulted in a finding against you?",
      },
      {
        key: "performedControlledFunctionWithoutApproval",
        label:
          "c) Been found to have performed a controlled function (or an equivalent function requiring approval by the FCA/PRA or any other regulatory body) without the requisite approval?",
      },
      {
        key: "investigatedForControlledFunction",
        label:
          "d) Been investigated for the possible performance of a controlled function (or an equivalent function requiring approval by the FCA/PRA or any other regulatory body) without the requisite approval, whether or not such investigation resulted in a finding against you?",
      },
      {
        key: "failedToComplyWithRegulations",
        label:
          "e) Been found to have failed to comply with an obligation under the Electronic Money Regulations 2011 or Payment Services Regulations 2009 to notify the FCA/PRA of the identity of a person acting in a position of influence over its electronic money or payment services business?",
      },
      {
        key: "subjectOfDisqualificationDirection",
        label:
          "f) Been the subject of disqualification direction under section 59 of the Financial Services Act 1986 or a prohibition order under section 56 FSMA, or received a warning notice proposing that such a direction or order be made, or received a private warning?",
      },
    ],
  };

  const anyYes = isAnyYesSelectedS7(formData);

  // files
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = Array.from(e.dataTransfer.files);
    setFormData((prev) => ({
      ...prev,
      files: [...(prev.files || []), ...files],
    }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setFormData((prev) => ({ ...prev, files }));
  };

  const handleRemoveFile = (indexToRemove) => {
    setFormData((prev) => ({
      ...prev,
      files: (prev.files || []).filter((_, i) => i !== indexToRemove),
    }));
  };

  // Check if section has any "Yes" values
  const hasYesInSection = (sectionKeys) => {
    return sectionKeys.some((key) => formData[key] === true);
  };

  // Helper to check each section
  const sectionHasYes = {
    "7_01": hasYesInSection([
      "criminalOffence",
      "criminalOffenceRelatedToFraud",
      "criminalOffenceRelatedToCompanies",
      "criminalProceedings",
      "subjectToCriminalOffence",
      "otherConvictions",
      "arrestedForCriminalOffence",
      "produceDocuments",
      "firmConvictedOfCriminalOffence",
      "firmSummonedChargedInvestigated",
      "firmSubjectOfCriminalProceedings",
      "firmOrderedToProduceDocuments",
    ]),
    "7_02": hasYesInSection([
      "judgementDebt",
      "partyToCivilProceedings",
      "awareOfProceedingsAganistYou",
      "moreThanOneSetOfProceedings",
      "claimDebtFromYou",
      "currentJudgementDebt",
      "failedToSatisfyJudgementDebt",
      "filedForBankruptcy",
      "adjudgedBankrupt",
      "subjectOfBankruptcyRestrictions",
      "arrangementsWithCreditors",
      "assetsSequestrated",
      "involvedInProceedings",
      "financialObligations",
      "courtAdjudgedForMisconduct",
      "currentlyPartyToCivilProceedings",
      "awareOfCivilProceedings",
      "firmAdjudgedByCourt",
      "judgementDebtAganistFirm",
      "partyToCivilProceedingsAganistFirm",
      "firmPartOfcivilProceedings",
      "firmPartyToCivilProceedings",
      "woundUpFirm",
    ]),
    "7_03": hasYesInSection([
      "disqualifiedFromDirector",
      "subjectToProceedings",
      "subjectToInvestigation",
      "notifiedOfProceedings",
      "subjectOfInvestigationWithBusinessActivity",
      "refusedEntry",
      "complaintsAgainstYou",
      "arbitrationBoard",
    ]),
    "7_04": hasYesInSection([
      "suspendedByRegulatoryBody",
      "subjectOfDisciplinaryAction",
      "receivedWarning",
      "subjectOfInvestigationByRegulatoryBody",
      "requiredToProduceDocuments",
      "investigationByInspector",
      "ceasedOperating",
      "rejectedApplication",
      "subjectOfCivilAction",
      "paymentServices",
      "convictedOdCriminalOffence",
      "boardofDirectorsNotGrantedRelease",
      "carriedOnActivitiesWithoutAuthorization",
      "investigatedForCarryingOnActivities",
      "performedControlledFunctionWithoutApproval",
      "investigatedForControlledFunction",
      "failedToComplyWithRegulations",
      "subjectOfDisqualificationDirection",
    ]),
    "7_05": hasYesInSection([
      "conflictPerformanceofControlledFunctions",
      "qualifyingOwnership",
      "closeRelativesOwnershipShares",
      "closeRelativesFinancialRelations",
      "conflictOfInterest",
      "otherRelevantInformation",
    ]),
  };

  // Handle section-specific file upload and removal
  const handleSectionFileChange = (sectionKey, e) => {
    const files = Array.from(e.target.files);
    setFormData((prev) => ({
      ...prev,
      [sectionKey]: files,
    }));
  };

  const handleRemoveSectionFile = (sectionKey, indexToRemove) => {
    setFormData((prev) => ({
      ...prev,
      [sectionKey]: (prev[sectionKey] || []).filter(
        (_, i) => i !== indexToRemove,
      ),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowErrors(true);
    sectionTopRef.current?.scrollIntoView({ behavior: "smooth" });

    const ok = runValidation(formData);

    // console.log("Section 7 Submit - Validation Result:", ok);
    // console.log("Section 7 Submit - Current Errors:", errors);

    // Save data regardless of validation status
    writeDataS7(formData);

    // Show appropriate alert based on validation result
    if (ok || shouldBypassValidation(auth.currentUser?.uid)) {
      setAlertMessage("Data saved successfully!");
      setAlertType("success");
    } else {
      setAlertMessage(
        "Data saved with errors. Please review the fields marked with errors.",
      );
      setAlertType("alert");
    }
  };
  return (
    <form className="section-form" onSubmit={handleSubmit} ref={sectionTopRef}>
      {alertMessage && (
        <AlertBanner
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertMessage("")}
        />
      )}
      <h3>Section 7 – Fitness and Propriety</h3>
      <div className="Content">
        If you answer ‘Yes’ to any of the questions in the below sections,
        please provide all details in the Additional Information in the
        respective section and upload any relevant documents.
      </div>

      <CollapsibleSection
        title="7.01 Criminal Proceedings"
        isCollapsed={collapsedSections.criminalProceedings}
        onToggle={(e) => toggleSection("criminalProceedings", e)}
      >
        <div className="Content">
          When answering the questions in this section you should include
          matters whether in the UK or overseas. By virtue of the Rehabilitation
          of Offenders Act 1974 (Exceptions) Order 1975, you are the subject to
          the law of England and Wales, you must disclose spent convictions and
          cautions (other than a protected conviction or caution). In the
          following questions, you should include all matters even when the
          arrest, charge, prosecution or investigation did not result in a
          conviction, and in respect of 7.01.4, even where you were not the
          subject of the investigation.
        </div>
        <div className="Content">7.01.1</div>
        {renderOptions("options_7_01_1")}

        <div className="Content">7.01.2</div>
        <div className="input-group-row">
          <div className="Content">
            Do you have any convictions for any offences other than those above
            (excluding traffic offences that did not result in a ban from
            driving or did not involve driving without insurance)?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="otherConvictions"
              value={formData.otherConvictions}
              onChange={handleChange}
              error={renderError("otherConvictions")}
            />
          </div>
        </div>
        <div className="Content">7.01.3</div>
        <div className="input-group-row">
          <div className="Content">
            Have you ever been arrested or charged with any criminal offence or
            been the subject of any criminal investigation? (Youshould include
            all matters even if the arrest, charge or investigation did not
            result in a conviction)
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="arrestedForCriminalOffence"
              value={formData.arrestedForCriminalOffence}
              onChange={handleChange}
              error={renderError("arrestedForCriminalOffence")}
            />
          </div>
        </div>
        <div className="Content">7.01.4</div>
        <div className="input-group-row">
          <div className="Content">
            Have you ever been ordered to produce documents pursuant to any
            criminal investigation or been subject of a search (with or without
            a warrant) pursuant to any criminal investigation?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="produceDocuments"
              value={formData.produceDocuments}
              onChange={handleChange}
              error={renderError("produceDocuments")}
            />
          </div>
        </div>
        <div className="Content">
          7.01.5 Has any firm at which you held a position of influence ever:
        </div>
        {renderOptions("options_7_01_5")}
        {/* LIBIF/IFS Qualifications */}

        {sectionHasYes["7_01"] && (
          <SectionAdditionalInfo
            sectionNumber="7_01"
            formData={formData}
            errors={errors}
            showErrors={showErrors}
            isSubmitted={isSubmitted}
            onTextChange={handleChange}
            onFileChange={handleSectionFileChange}
            onFileRemove={handleRemoveSectionFile}
          />
        )}
      </CollapsibleSection>

      <CollapsibleSection
        title="7.02 Civil Proceedings"
        isCollapsed={collapsedSections.civilProceedings}
        onToggle={(e) => toggleSection("civilProceedings", e)}
      >
        <div className="Content">7.02.1</div>
        <div className="input-group-row">
          <div className="Content">
            Have you ever been the subject of a judgement debt or aware against
            you?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="judgementDebt"
              value={formData.judgementDebt}
              onChange={handleChange}
              error={renderError("judgementDebt")}
            />
          </div>
        </div>
        <div style={{ gap: "15px", display: "flex", flexDirection: "column" }}>
          <div className="Content">
            Please give a full explanation in the text box at the end of the
            section of the events in question
          </div>
          <div className="Content">
            You should include all Count Court Judgement (s) (CCJs) made against
            the candidate (whether satisfied or not) and;
          </div>
          <div className="Content">
            i. The sum and data of all judgement debts, awards or CCJs (whether
            satisfied or not); and
          </div>
          <div className="Content">
            ii. The total number of all judgement debts, awards or CCJs ordered
          </div>
        </div>
        <div>
          <div className="Content">7.02.2</div>
          <div className="input-group-row">
            <div className="Content">
              Have you ever been party to any civil proceedings which resulted
              in any order against you (other than a judgement debt or award
              reffered to in 7.02.1 above)?
              <span style={{ color: "var(--Error)" }}> *</span>
            </div>
            <div className="input-group">
              <YesNoRadio
                name="partyToCivilProceedings"
                value={formData.partyToCivilProceedings}
                onChange={handleChange}
                error={renderError("partyToCivilProceedings")}
              />
            </div>
          </div>
          <div className="Content-Small">
            (You could include, for example, injunctions or employment tribunal
            proceedings)
          </div>
        </div>
        <div className="Content">7.02.3</div>
        <div className="Content">Are you aware of: </div>
        {renderOptions("options_7_02_3")}

        <div className="Content">7.02.4</div>
        <div className="input-group-row">
          <div className="Content">
            Do you have any current judgement debts (including CCJs) made under
            a court order still outstanding, whether in full or in part?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="currentJudgementDebt"
              value={formData.currentJudgementDebt}
              onChange={handleChange}
              error={renderError("currentJudgementDebt")}
            />
          </div>
        </div>
        <div className="Content">7.02.5</div>
        <div className="input-group-row">
          <div className="Content">
            Have you ever failed to satisfy any such judgement debts (including
            CCJs) made under a court order still outstanding,whether in full or
            part, within one year of the order being made?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="failedToSatisfyJudgementDebt"
              value={formData.failedToSatisfyJudgementDebt}
              onChange={handleChange}
              error={renderError("failedToSatisfyJudgementDebt")}
            />
          </div>
        </div>
        <div className="Content">7.02.6</div>
        {renderOptions("options_7_02_6")}
        <div className="Content">7.02.7</div>
        <div className="input-group-row">
          <div className="Content">
            Do you, or any undertaking under their management, have any
            outstanding financial obligations arising from regulated activities,
            which have been carried out in the past? (whether or not in the UK
            or overseas)
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="financialObligations"
              value={formData.financialObligations}
              onChange={handleChange}
              error={renderError("financialObligations")}
            />
          </div>
        </div>
        <div className="Content">7.02.8</div>
        <div className="input-group-row">
          <div className="Content">
            Have you ever been adjudged by a court or tribunal (whether
            criminal, civil or administrative) for any fraud, misfeasance,
            negligence, wrongful trading or other misconduct?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="courtAdjudgedForMisconduct"
              value={formData.courtAdjudgedForMisconduct}
              onChange={handleChange}
              error={renderError("courtAdjudgedForMisconduct")}
            />
          </div>
        </div>
        <div className="Content">7.02.9 Are you currently?</div>
        {renderOptions("options_7_02_9")}

        <div className="Content">7.02.10 </div>
        <div className="Content">
          Has any firm at which you hold or have held a position of influence
          ever been:
        </div>
        {renderOptions("options_7_02_10")}

        <div className="Content">7.02.11 </div>
        <div className="Content">
          Is any firm at which you currently hold or have held, within the last
          12 months from the date of submission of this firm, a position of
          influence currently:
        </div>
        {renderOptions("options_7_02_11")}
        <div className="Content">7.02.12</div>
        <div className="input-group-row">
          <div className="Content">
            Has any company, partnership or unincorporated association of which
            you are or have been a controller, director, senior manager, partner
            or company secretary, in the United Kingdom, or elsewhere, at any
            time during their involvement, or within one year of such an
            involvement, been put into liquidation, wound up, ceased trading,
            had a receiver or administrator appointed or entered into any
            voluntary arrangement with its creditors?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="woundUpFirm"
              value={formData.woundUpFirm}
              onChange={handleChange}
              error={renderError("woundUpFirm")}
            />
          </div>
        </div>

        {sectionHasYes["7_02"] && (
          <SectionAdditionalInfo
            sectionNumber="7_02"
            formData={formData}
            errors={errors}
            showErrors={showErrors}
            isSubmitted={isSubmitted}
            onTextChange={handleChange}
            onFileChange={handleSectionFileChange}
            onFileRemove={handleRemoveSectionFile}
          />
        )}
      </CollapsibleSection>

      <CollapsibleSection
        title="7.03 Business and Employment Matters"
        isCollapsed={collapsedSections.businessEmployment}
        onToggle={(e) => toggleSection("businessEmployment", e)}
      >
        <div className="Content">7.03.1 Have you ever been:</div>
        {renderOptions("options_7_03_1")}
        <div className="Content">7.03.2</div>
        <div className="input-group-row">
          <div className="Content">
            Have you ever been refused entry to, or been dismissed, suspended or
            requested to resign from, any professional, vocation, office or
            employment, or from any fiduciary office or position of trust
            whether or not remunerated?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="refusedEntry"
              value={formData.refusedEntry}
              onChange={handleChange}
              error={renderError("refusedEntry")}
            />
          </div>
        </div>

        <div className="Content">7.03.3</div>
        <div className="input-group-row">
          <div className="Content">
            Do you have any material written complaints made against you by your
            clients or former clients in the last five years which you have
            accepted, or which are awaiting determination, or have been upheld –
            by an ombudsman or complaints scheme?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="complaintsAgainstYou"
              value={formData.complaintsAgainstYou}
              onChange={handleChange}
              error={renderError("complaintsAgainstYou")}
            />
          </div>
        </div>

        <div className="Content">7.03.4</div>
        <div className="input-group-row">
          <div className="Content">
            Have you ever participated in an arbitration board?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="arbitrationBoard"
              value={formData.arbitrationBoard}
              onChange={handleChange}
              error={renderError("arbitrationBoard")}
            />
          </div>
        </div>

        {sectionHasYes["7_03"] && (
          <SectionAdditionalInfo
            sectionNumber="7_03"
            formData={formData}
            errors={errors}
            showErrors={showErrors}
            isSubmitted={isSubmitted}
            onTextChange={handleChange}
            onFileChange={handleSectionFileChange}
            onFileRemove={handleRemoveSectionFile}
          />
        )}
      </CollapsibleSection>

      <CollapsibleSection
        title="7.04 Regulatory Matters"
        isCollapsed={collapsedSections.regulatoryMatters}
        onToggle={(e) => toggleSection("regulatoryMatters", e)}
      >
        <div className="Content">7.04.1 </div>
        <div className="Content">
          In relation to activities regulated by the FCA and/or PRA or any other
          regulatory body have:
        </div>
        <div className="Content">• You, or</div>
        <div className="Content">
          • Any company, partnership or unincorporated associate of which you
          are or have been a controller, director, senior manager, partner or
          company secretary, during the candidate’s association with the entity
          and for a period of three years after you ceased to be associated with
          it ever…..
        </div>
        {renderOptions("options_7_04_1")}

        <div className="Content">7.04.2 Regulatory Matters</div>
        <div className="Content">
          In relation to activities regulated by the FCA/PRA or any other
          regulator body, have you or any firm at which you hold or have held a
          position of influence at any time during and, within one year of your
          association with the firm ever:
        </div>
        {renderOptions("options_7_04_2")}
        {sectionHasYes["7_04"] && (
          <SectionAdditionalInfo
            sectionNumber="7_04"
            formData={formData}
            errors={errors}
            showErrors={showErrors}
            isSubmitted={isSubmitted}
            onTextChange={handleChange}
            onFileChange={handleSectionFileChange}
            onFileRemove={handleRemoveSectionFile}
          />
        )}
      </CollapsibleSection>

      <CollapsibleSection
        title="7.05 Other Matters"
        isCollapsed={collapsedSections.miscellaneous}
        onToggle={(e) => toggleSection("miscellaneous", e)}
      >
        <div className="Content">7.05.1 </div>
        <div className="input-group-row">
          <div className="Content">
            Are you, in the role to which the application relates, aware of any
            business interests, employment obligations, or any other
            circumstance which may conflict with the performance of the
            controlled functions for which approval is now being sought in the
            respect of your control of the firm with your role as controller of
            the applicant firm or your role as controller?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="conflictPerformanceofControlledFunctions"
              value={formData.conflictPerformanceofControlledFunctions}
              onChange={handleChange}
              error={renderError("conflictPerformanceofControlledFunctions")}
            />
          </div>
        </div>
        <div className="Content">7.05.2</div>
        <div className="Content">
          For large NDF firms only. Candidates for CF30 only, are not required
          to answer this question.
        </div>
        <div className="Content">Do you have, or know of, any:</div>
        <div className="input-group-row">
          <div className="Content">
            a) Qualifying ownership or any other form of substantial influence
            in the firm or group, or any other companies?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="qualifyingOwnership"
              value={formData.qualifyingOwnership}
              onChange={handleChange}
              error={renderError("qualifyingOwnership")}
              na={true}
            />
          </div>
        </div>
        <div className="sizebox"></div>
        <div className="Content">If yes, please provide:</div>
        <div className="input-group-row">
          <div className="Content">
            1. Company name and registration number
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <InputField
              name="companyName"
              value={formData.companyName}
              placeholder="Company Name"
              onChange={handleChange}
              error={errors.companyName}
            />
          </div>
        </div>
        <div className="sizebox"></div>
        <div className="input-group-row">
          <div className="Content">
            2. Company registration number
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <InputField
              name="companyRegistrationNumber"
              value={formData.companyRegistrationNumber}
              placeholder="Company Registration Number"
              onChange={handleChange}
              error={errors.companyRegistrationNumber}
            />
          </div>
        </div>{" "}
        <div className="sizebox"></div>
        <div className="input-group-row">
          <div className="Content">
            3. Nature and scope of the operations
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <InputField
              name="natureOfOperations"
              value={formData.natureOfOperations}
              placeholder=""
              onChange={handleChange}
              error={errors.natureOfOperations}
            />
          </div>
        </div>{" "}
        <div className="sizebox"></div>
        <div className="input-group-row">
          <div className="Content">
            4. The registered office of the company
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <InputField
              name="registeredOffice"
              value={formData.registeredOffice}
              placeholder=""
              onChange={handleChange}
              error={errors.registeredOffice}
            />
          </div>
        </div>{" "}
        <div className="sizebox"></div>
        <div className="input-group-row">
          <div className="Content">
            5. Possession in percentage
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <InputField
              name="possessionInPercentage"
              value={formData.possessionInPercentage}
              placeholder=""
              type="number"
              onChange={handleChange}
              error={errors.possessionInPercentage}
            />
          </div>
        </div>
        <div className="sizebox"></div>
        <div className="input-group-row">
          <div className="Content">
            a) Close relatives with ownership shares in the firm or group?{" "}
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="form-row">
            <YesNoRadio
              name="closeRelativesOwnershipShares"
              value={formData.closeRelativesOwnershipShares}
              onChange={handleChange}
              error={errors.closeRelativesOwnershipShares}
            />
            <InputField
              name="nameOfCloseRelativesOwnershipShares"
              value={formData.nameOfCloseRelativesOwnershipShares}
              onChange={handleChange}
              placeholder="Name of Close Relatives"
              error={errors.nameOfCloseRelativesOwnershipShares}
            />
          </div>
        </div>
        <div className="sizebox"></div>
        <div className="input-group-row">
          <div className="Content">
            b) Close relatives with any other financial relations in the firm or
            group? <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="form-row">
            <YesNoRadio
              name="closeRelativesFinancialRelations"
              value={formData.closeRelativesFinancialRelations}
              onChange={handleChange}
              error={errors.closeRelativesFinancialRelations}
            />
            <InputField
              name="nameOfCloseRelativesFinancialRelations"
              value={formData.nameOfCloseRelativesFinancialRelations}
              placeholder="Name of Close Relatives *"
              onChange={handleChange}
              error={errors.nameOfCloseRelativesFinancialRelations}
            />
          </div>
        </div>
        <div className="sizebox"></div>
        <div className="input-group-row">
          <div className="Content">
            c) Any other comments that may give rise to a conflict of interest{" "}
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="conflictOfInterest"
              value={formData.conflictOfInterest}
              onChange={handleChange}
              error={errors.conflictOfInterest}
            />
          </div>
        </div>
        <div className="Content">7.05.3</div>
        <div className="input-group-row">
          <div className="Content">
            Are you aware of any other information relevant to this application
            that we might reasonably expect from you?
            <span style={{ color: "var(--Error)" }}> *</span>
          </div>
          <div className="input-group">
            <YesNoRadio
              name="otherRelevantInformation"
              value={formData.otherRelevantInformation}
              onChange={handleChange}
              error={errors.otherRelevantInformation}
            />
          </div>
        </div>
      </CollapsibleSection>

      {/* <div className="Content">Declarations and Signatures</div>
      <div className="Content">
        Application to perform controlled functions under the approved persons
        regime to the Financial Conduct Authority
      </div>
      <div className="Content">Declaration of Candidate</div>
      <div className="form-row">
        <div className="Content-Small">
          Knowingly or recklessly giving the FCA and/or PRA information which is
          false or misleading in a material particular may be a criminal offence
          (section 398 of the Financial Services and Markets Act 2000).
        </div>
        <div className="Content-Small">
          It should not be assumed that information is known to the FCA and/or
          PRA merely because it is in the public domain or has previously been
          disclosed to the FCA and/or PRA or another regulatory body. If there
          is any doubt about the relevance of information, it should be
          included.
        </div>
        <div className="Content-Small">
          For the purposes of complying with the Data Protection Act, the
          personal information provided in this Form will be used by the FCA and
          PRA to discharge its statutory functions under the Financial Services
          and Markets Act 2000 and other relevant legislation, and will not be
          disclosed for any other purpose without the permission of the
          applicant.
        </div>
        <div className="Content-Small">
          With reference to the above, the FCA and/or PRA may seek to verify the
          information given in this Form including answers pertaining to fitness
          and propriety. This may include a credit reference check. In signing
          the form below:
        </div>
        <div className="Content-Small">
          a. I authorise the FCA and/or PRA to make such enquiries and seek such
          further information as it thinks appropriate in the course of
          verifying the information given in this Form. Individual candidates
          may be required to apply to the Disclosure and Barring Service for a
          search to be made as to whether any criminal records are held in
          relation to them and to disclose the result of that search to us. I
          also understand that the results of these checks may be disclosed to
          the firm submitting this application
        </div>
        <div className="Content-Small">
          b. I confirm that the information in this Form is accurate and
          complete to the best of my knowledge and belief and that I have read
          the notes to this Form
        </div>
        <div className="Content-Small">
          c. I confirm that I understand the regulatory responsibilities of my
          proposed role as set out in the Statements of Principle and Code of
          Practice for Approved Persons
        </div>
      </div> */}
      {/* <div>
        <div style={{ gap: "8px", width: "400px" }} className="input-group">
          <a
            href="https://www.handbook.fca.org.uk/handbook"
            target="_blank"
            rel="noopener noreferrer"
            className="Content-Bold-Underline"
            style={{ textDecoration: "underline" }}
          >
            FCA Handbook
          </a>
          <a
            href="http://www.bankofengland.co.uk/PRA"
            target="_blank"
            rel="noopener noreferrer"
            className="Content-Bold-Underline"
            style={{ textDecoration: "underline" }}
          >
            Prudential regulation
          </a>
        </div>
        <CheckboxGrid
          options={[
            "Tick here to confirm you have read and understood this declaration:",
          ]}
          columns={1}
          formDataKey="confirmedDeclaration"
          selectedOptions={
            formData.confirmedDeclaration
              ? [
                  "Tick here to confirm you have read and understood this declaration:",
                ]
              : []
          }
          error={errors.confirmedDeclaration}
          disabled={isSubmitted}
          handleCheckboxChange={(e, key, option) => {
            setFormData((prev) => ({
              ...prev,
              confirmedDeclaration: e.target.checked,
            }));
            if (e.target.checked) {
              setErrors((prev) => ({ ...prev, confirmedDeclaration: "" }));
            }
          }}
        />
        {errors.confirmedDeclaration && (
          <span className="error-message">{errors.confirmedDeclaration}</span>
        )}
      </div> */}
      {!isSubmitted && <PrimaryButton label="SAVE" onClick={handleSubmit} />}
    </form>
  );
};

export default Section7;
